export default __webpack_public_path__ + "static/media/PRINTtoken.49d3ade6.png";